// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".newsletter-link .btn{text-align:left}.newsletter-link img{padding-bottom:.375rem;width:1.3125rem;height:auto}.newsletter-modal .modal-dialog .modal-content{padding-bottom:2.8125rem}.newsletter-modal .modal-dialog .modal-content .modal-header{margin-bottom:0}.newsletter-modal p{color:#51596c;font-size:1.125rem;line-height:1.6875rem}.newsletter-modal a{display:inline-block;font-size:1.125rem}", ""]);
// Exports
module.exports = exports;
